import { render, staticRenderFns } from "./global-all-user-mail.html?vue&type=template&id=4de28876&scoped=true&"
import script from "./global-all-user-mail.js?vue&type=script&lang=js&"
export * from "./global-all-user-mail.js?vue&type=script&lang=js&"
import style0 from "./global-all-user-mail.scss?vue&type=style&index=0&id=4de28876&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de28876",
  null
  
)

export default component.exports